import {
    IconButton as UiIconButton,
    ListItemButton as UiListItemButton,
    Skeleton as UiSkeleton,
    styled,
    Typography as UiTypography,
    List as UiList,
    Tooltip as UiTooltip,
    Typography,
} from "@mui/material"

import { KeyboardArrowDownIcon, KeyboardArrowUpIcon } from "@l2r-front/l2r-icons"

const ICON_SIZE = 36

type StyledListItemButtonProps = {
    highlighted?: boolean,
    isDisabled?: boolean,
    selected?: boolean,
}

export const ListItemButton = styled(UiListItemButton, {
    shouldForwardProp: (prop) => prop !== "highlighted" && prop !== "selected" && prop !== "isDisabled",
})<StyledListItemButtonProps>(({ isDisabled, highlighted, selected, theme }) => {
    const border = selected ? `2px solid ${theme.palette["primary"].main}`
        : highlighted ? `2px solid ${theme.palette.divider}`
            : isDisabled ? `1px dashed ${theme.palette["_components/input/enabledBorder"].main}`
                : `1px solid ${theme.palette.divider}`

    const horizontalPadding = `calc(${!selected && !highlighted ? theme.spacing(3) + " + 1px" : theme.spacing(3)})`
    const verticalPadding = `calc(${!selected && !highlighted ? theme.spacing(1) + " + 1px" : theme.spacing(1)})`

    return ({
        backgroundColor: `transparent !important`,
        border: border,
        borderRadius: 12,
        color: isDisabled && theme.palette["action/active light"].main,
        display: "flex",
        justifyContent: "space-between",
        marginBottom: theme.spacing(3),
        minHeight: 46,
        padding: `${verticalPadding} ${horizontalPadding} ${verticalPadding} ${horizontalPadding}`,
        width: "100%",
        boxSizing: "border-box",
        cursor: isDisabled ? "default" : "pointer",
        "&:hover": {
            backgroundColor: !isDisabled && `${theme.palette.action.hover} !important`,
        },
    })
})

type SideContainerProps = {
    maxWidth?: string,
}

export const SideContainer = styled("div", {
    shouldForwardProp: (prop) => prop !== "maxWidth",
})<SideContainerProps>(({ theme, maxWidth }) => ({
    display: "flex",
    alignItems: "center",
    maxWidth,
    gap: theme.spacing(3),
    marginLeft: theme.spacing(3),
}))

interface StyledImageProps {
    highlighted?: boolean;
    isDisabled?: boolean;
}

export const Image = styled("img")<StyledImageProps>(({ isDisabled, theme }) => ({
    opacity: isDisabled ? 0.5 : 1,
    marginRight: theme.spacing(6),
    marginTop: -6,
    marginBottom: -6,
    height: ICON_SIZE,
    width: ICON_SIZE,
    objectFit: "contain",
}))

export const Count = styled(UiTypography)({
    marginLeft: "auto",
})

export const IconButton = styled(UiIconButton)(({ theme }) => ({
    marginLeft: theme.spacing(3),
}))

export const Skeleton = styled(UiSkeleton)(({ theme }) => ({
    height: 48,
    marginBottom: theme.spacing(2),
    transform: "scale(1)",
    width: "100%",
}))

export const ArrowDownIcon = styled(KeyboardArrowDownIcon)(() => ({
}))

export const ArrowUpIcon = styled(KeyboardArrowUpIcon)(() => ({
}))

export const List = styled(UiList)(({ theme }) => ({
    marginLeft: theme.spacing(6),
}))

export const ArrowText = styled(Typography)(({ theme }) => ({
    marginRight: theme.spacing(2),
}))

export const ArrowIconWrapper = styled("div")({
    cursor: "pointer",
})

type StyledTooltipProps = {
    displayArrowIcon?: boolean,
}

export const Tooltip = styled(UiTooltip, { shouldForwardProp: (prop) => prop !== "displayArrowIcon" })<StyledTooltipProps>(({ displayArrowIcon, theme }) => ({
    marginRight: theme.spacing(displayArrowIcon ? 3 : 5),
}))
